import { render, staticRenderFns } from "./event-info-form.vue?vue&type=template&id=36fdffba"
import script from "./event-info-form.vue?vue&type=script&lang=js"
export * from "./event-info-form.vue?vue&type=script&lang=js"
import style0 from "./event-info-form.vue?vue&type=style&index=0&id=36fdffba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports